import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import usedeletedata from '../../Hooks/useDeleteData';
import {
  AddCommunicationway,
  Delete_One_Communicationway,
  Get_All_Communicationway,
  Get_Error,
  Get_One_Communicationway,
  Update_One_Communicationway,
} from '../Types';

export const Add_Communicationway_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/communicationway`, body);

    dispatch({
      type: AddCommunicationway,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all communicationway data
export const GetCommunicationwayData = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/communicationway?iscommunicationwayactivate=true`);

    dispatch({
      type: Get_All_Communicationway,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all communicationway data not active
export const GetCommunicationwayDataNotActive = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/communicationway?iscommunicationwayactivate=false`);

    dispatch({
      type: Get_All_Communicationway,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one communicationway data
export const GetOneCommunicationwayData = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/communicationway/${id}`);

    dispatch({
      type: Get_One_Communicationway,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one communicationway data
export const UpdateOneCommunicationData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/communicationway/${id}`, body);

    dispatch({
      type: Update_One_Communicationway,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one communicationway data
export const DeleteOneCommunicationData = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/communicationway/${id}`);

    dispatch({
      type: Delete_One_Communicationway,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
